import DibbleConfigs from "./dibble-config";

const DibbleAPI = {
    endpoint: DibbleConfigs.apiEndpoint,
    apiDateFormat: "YYYY-MM-DD",
    apiDateFormatFull: "YYYY-MM-DD hh:mm:ss",
    api: {
        login: 'User/login',

        getUsers: 'Admin/get_users_list',
        getUserProfile: 'General/get_user_profile',
        getConversation: 'User/get_system_message_conversation',
        admin: {
            getUsers: "Admin/get_users_list",
            getBusinessUsers: "Admin/get_businesses_list",
            getCharacterTraits: "Admin/get_character_traits",
            addChareacterTraits: "Admin/add_character_trait",
            updateCharacterTraits: "Admin/update_character_trait",
            updateCharacterTraitsStatus: "Admin/set_character_trait_active",

            getFeedbackReasons: "Admin/get_feedbacks_reasons",
            addFeedbackReason: "Admin/add_feedback_reason",
            updateFeedbackReasons: "Admin/update_feedback_reason",
            updateFeedbackReasonsStatus: "Admin/set_feedback_reason_active",
            
            getColorScheme: "Admin/get_color_scheme",
            getAllMessages: "Admin/get_all_messages",
            upateMessageStatus: "Admin/update_system_message_status",
            replyMessage: "Admin/send_system_message",
        },
        
        /* | Users | */
        getUser: 'AdminManagement/get_user',
        getUserStatistic: 'AdminManagement/get_user_statistics',
        getAllUserStatistic: 'AdminManagement/get_all_users_statistics',
        setUserActive: 'User/set_active',
        blockUser: "Admin/block_user",
        sendHeritage: 'AdminManagement/send_heritage',
        cancelSendHeritage: 'AdminManagement/cancel_send_heritage',
        memory: {
            get:"Memory/get",
        },
        report: {
            gets: "AdminManagement/get_all_reports",
            removeContent: "Report/remove_content",
            deleteReportedMemory: "AdminManagement/delete_reported_memory",
            changeStatus: "AdminManagement/change_report_status",
            getInfo: "Report/get_info",
        },
        questionnaire: {
            getAll: "Questionnaire/get_all_questionnaires",
            getQuestionnaireDetails: "Questionnaire/get_questionnaire",
            setQuestionActive: "Questionnaire/set_questionnaire_active",
            addQuestionnaire: "Questionnaire/add_questionnaire",
            updateQuestionnaire: "Questionnaire/update_questionnaire",
            addQuestion: "Questionnaire/add_question",
            updateQuestion: "Questionnaire/update_question",
            deleteQuestion: "Questionnaire/delete_question",
            setQuestionsOrder: "Questionnaire/set_questions_order",
            addFieldToTemplate: "AdminManagement/add_field_to_questionnaire_template",
            addQuestionnaireInCustomizedLang: "AdminManagement/add_questionnaire_in_customized_language",
            changeFieldOrderIndex: "AdminManagement/change_questionnaire_field_order_index",
            updateQuestionnaireStatus: "AdminManagement/update_questionnaire_active_status",
            updateQuestionnaireField: "AdminManagement/update_questionnaire_field",
            updateQuestionnaireInCustomizeLang: "AdminManagement/update_questionnaire_in_customized_language",
            updateQuestionnaireInCustomizeLangQuestion: "AdminManagement/update_questionnaire_in_customized_language_question",
            getQuestionnaireInCustomizeLang: "AdminManagement/get_questionnaire_in_customized_language_questions",
            getQuestionnaireTemplateField: "AdminManagement/get_questionnaire_template_fields" 
        }
    },
    isResponseSuccess(responseData) {
        return parseInt(responseData.rc) === 0;
    }
}

export default DibbleAPI;
